export const selectDashboardStats = (state) => state.dashboard.dashboardStats;
export const selectSalesOverview = (state) => state.dashboard.salesOverview;
export const selectRecentOrders = (state) => state.dashboard.recentOrders;
export const selectTopSellingProducts = (state) => state.dashboard.topSellingProducts;
export const selectDashboardLoading = (state) => state.dashboard.loading;
export const selectDashboardError = (state) => state.dashboard.error;
export const selectDashboardSuccess = (state) => state.dashboard.success;

// Derived selectors
export const selectTotalRevenue = (state) => state.dashboard.dashboardStats.totalRevenue;
export const selectTotalSales = (state) => state.dashboard.dashboardStats.totalSales;
export const selectTotalCustomers = (state) => state.dashboard.dashboardStats.totalCustomers;
export const selectTotalOrders = (state) => state.dashboard.dashboardStats.totalOrders;
